import { checkIsTypeScriptProject as checkIsTypeScriptProject$1 } from "@prismicio/plugin-kit/fs";
const checkIsTypeScriptProject = async (args) => {
  return args.options.typescript ?? checkIsTypeScriptProject$1({ helpers: args.helpers });
};
export {
  checkIsTypeScriptProject
};
//# sourceMappingURL=checkIsTypeScriptProject.js.map
